import { Box, Flex } from '@chakra-ui/react'
import { css } from '@emotion/react'
import IconLink from 'front-end/src/components/common/icon/IconLink'
import React, { FC } from 'react'
import { WorkspaceBookmarkTypeEnum } from '../../../../graphql/private/PrivateSchemaTypes'
import { TypeOfElement } from '../../../../../../types/generic'
import { BookmarkListQuery } from '../../workspacePage.codegen'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'

export interface IBookmarkProps {
  data: TypeOfElement<
    NonNullable<BookmarkListQuery['workspace']>['bookmarkList']
  >
}

export const Bookmark: FC<IBookmarkProps> = (props) => {
  const { theme } = useLooopTheme()
  const { title, url, image, type } = props.data
  const isBigger = type === WorkspaceBookmarkTypeEnum.BIG

  let imagePath = image?.original || image?.largeCdnUrl

  return (
    <Flex
      flexDirection="row"
      position="relative"
      flexGrow={1}
      height={isBigger ? '80px' : '32px'}
      backgroundColor={theme.colors.white}
      borderRadius="8px"
      overflow="hidden"
      boxShadow="1px 1px 0 0 rgba(0,0,0,0.02), 2px 2px 15px -2px rgba(8,16,24,0.06)"
      css={css`
        &:hover {
          transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
          transform: scale3d(1.005, 1.005, 1) translateY(-1px);
          box-shadow: 0 6px 10px rgba(8, 16, 24, 0.1);
          cursor: pointer;
        }
        &:active {
          transform: scale3d(1.005, 1.005, 1) translateY(0px);
          box-shadow: 0 4px 6px rgba(8, 16, 24, 0.1);
        }
      `}
      onClick={() => {
        if (url) {
          const win = window.open(url, '_blank')
          win?.focus()
        }
      }}
    >
      <Flex
        width="36px"
        backgroundColor={theme.colors.buttonPrimary[500]}
        color={theme.colors.white}
        alignItems={isBigger ? 'flex-end' : 'center'}
        justifyContent="center"
        paddingBottom={isBigger ? '13px' : 0}
        minWidth="36px"
      >
        <IconLink />
      </Flex>
      <Flex
        alignItems={isBigger ? 'flex-end' : 'center'}
        padding="0 12px 0"
        paddingBottom={isBigger ? '13px' : 0}
        flexGrow={1}
        color={isBigger && image ? theme.colors.white : theme.colors.grey.dark}
        whiteSpace={!(isBigger && image) ? 'nowrap' : 'normal'}
        backgroundImage={
          isBigger && imagePath
            ? `linear-gradient(180deg, rgba(255,255,255,0.00) 35%, rgba(81,81,81,0.5) 64%, rgba(0,0,0,0.7) 100%), url('${imagePath}')`
            : 'none'
        }
        backgroundSize="cover"
      >
        <Box
          maxHeight="75%"
          overflow="hidden"
          textOverflow={!(isBigger && image) ? 'ellipsis' : 'clip'} // This line screams this is prop is not available but https://github.com/chakra-ui/chakra-ui/issues/662
          data-test="BookmarkItem"
        >
          {title}
        </Box>
      </Flex>
      {props.children}
    </Flex>
  )
}
